import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
import { Box, Heading, useToast } from '@chakra-ui/react';
import SurveyPeriodForm from './SurveyPeriodForm';

const SurveyPeriodEditPage = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSurveyPeriod = async () => {
      try {
        const res = await axios.get(`/survey_periods/${id}`);
        setFormData(res.data);
      } catch (error) {
        console.error('Error loading survey period:', error);
        toast({
          title: 'Failed to load survey period.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetchSurveyPeriod();
  }, [id, toast]);

  const handleUpdate = async (updatedData) => {
    setIsSubmitting(true);
    try {
      await axios.put(`/survey_periods/${id}`, updatedData);
      toast({
        title: 'Survey period updated.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      navigate('/app/survey_periods');
    } catch (error) {
      console.error('Error updating survey period:', error);
      toast({
        title: 'Failed to update survey period.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box px={6} py={8}>
      <Heading as="h2" size="lg" mb={6} textAlign="center">
        Edit Survey Period
      </Heading>
      {formData ? (
        <SurveyPeriodForm onSubmit={handleUpdate} initialData={formData} isSubmitting={isSubmitting} />
      ) : (
        <div>Loading...</div>
      )}
    </Box>
  );
};

export default SurveyPeriodEditPage;